







































import { AuthenticationDispatches } from '@/store/authentication.module';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HomeView extends Vue {
  protected logout(): void {
    this.$store.dispatch(AuthenticationDispatches.LOGOUT);
  }
}
